import { CustomTag } from "../../../Tags";
import { TagColors } from "../../../Tags/utils/theme";

/**
 * 차량등록 enum
 */
export enum VehicleRegistStatus {
  /**
   * 차량등록 - 직접등록
   */
  MANUAL = "차량등록 - 직접등록",
  /**
   * 차량등록 - 차량번호/소유주 입력
   */
  AUTOMATIC = "차량등록 - 차량번호/소유주 입력",
  /**
   * 제품 상세페이지
   */
  SELECT = "제품 상세페이지",
  /**
   * 담당자 수기입력
   */
  ADMIN = "담당자 수기입력",
  /**
   * 차량검색(미등록)
   * @history (240523) 신규 추가
   */
  SEARCH = "차량검색(미등록)",
  /**
   * 알 수 없음
   * @notice 구데이터
   */
  UNKNOWN = "알 수 없음",
}

/**
 * 차량등록 key type
 */
export type VehicleRegistStatusType = keyof typeof VehicleRegistStatus;
/**
 * 차량등록별 컬러
 */
export const vehicleRegistStatusTypeColor: {
  [key: string]: TagColors;
} = {
  MANUAL: "primary",
  AUTOMATIC: "primary",
  SELECT: "blue",
  ADMIN: "black",
  SEARCH: "primary",
  UNKNOWN: "gray",
};

interface VehicleRegistStatusTagProps {
  value: VehicleRegistStatusType;
}

/**
 * 차량등록 태그
 * @param value
 * @returns
 */
export const VehicleRegistStatusTag: React.FC<VehicleRegistStatusTagProps> = ({
  value,
}) => {
  return (
    <>
      {VehicleRegistStatus[value] ? (
        <CustomTag colors={vehicleRegistStatusTypeColor[value]}>
          {VehicleRegistStatus[value]}
        </CustomTag>
      ) : (
        "-"
      )}
    </>
  );
};
